import React, { FC, useEffect, useRef, useState } from 'react';
import GoogleMapReact from 'google-map-react';

import { GOOGLE_MAP_API_KEY } from '~/env';
import { useCurrentBusiness } from '~/hooks/businesses';
import countries from '~/utils/countries.json';

const GoogleMap: FC<
  Omit<GoogleMapReact.Props, 'bootstrapURLKeys' | 'defaultCenter' | 'defaultZoom'> & {
    defaultCountry?: string;
  }
> = (props) => {
  const { defaultCountry, center, zoom, ...rest } = props;

  const business = useCurrentBusiness();
  const resultDefaultCountry = defaultCountry || business.data?.country;

  const [isMapReady, setIsMapReady] = useState(false);

  const handleSetContryCoordsRef = useRef<(country: string) => void>();
  const handleApiLoaded = (map: any, maps: any) => {
    const handleSetContryCoords = (country?: string) => {
      if (!isValidCoords(center)) {
        const c = country && (countries as any)[country.toLowerCase()];
        if (c) {
          console.log(`fit bounds for ${country}`);
          map.fitBounds({
            east: c.boundingBox.ne.lon,
            north: c.boundingBox.ne.lat,
            south: c.boundingBox.sw.lat,
            west: c.boundingBox.sw.lon,
          });
        }
      }
    };
    handleSetContryCoordsRef.current = handleSetContryCoords;
    setIsMapReady(true);
  };

  useEffect(() => {
    if (resultDefaultCountry && isMapReady && handleSetContryCoordsRef.current) {
      handleSetContryCoordsRef.current(resultDefaultCountry);
    }
  }, [isMapReady, resultDefaultCountry]);

  if (!GOOGLE_MAP_API_KEY) return null;
  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: GOOGLE_MAP_API_KEY }}
      defaultCenter={{ lat: 0, lng: 0 }}
      center={center}
      defaultZoom={5}
      zoom={zoom}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      {...rest}
    />
  );
};

const isValidCoords = (coords: any) => {
  if (!coords) return false;
  return !Object.values(coords).every((item) => item === 0);
};

export default GoogleMap;
